<script>
    import { selectedItem } from '../../store/store.js';

    // Helper function to format currency
    function formatCurrency(value) {
        if (value === null || value === undefined) return 'N/A';
        return new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }

    // Helper function to format number
    function formatNumber(value) {
        if (value === null || value === undefined) return 'N/A';
        return new Intl.NumberFormat('sv-SE').format(value);
    }
</script>

<div class="key-value-table box">
    <div class="header-card">
        <h5><i class="fa-solid fa-chart-line fa-xs icon-prefix"></i> Ekonomisk Plan</h5>
    </div>

    <div class="info-grid">
        <!-- Total bostadsarea -->
        <div class="info-card">
            <div class="info-header">
                <i class="fa-solid fa-ruler-combined fa-sm icon-detail"></i>
                <h6>Total bostadsarea</h6>
            </div>
            <div class="info-value">
                {$selectedItem.total_bostadsarea_kvm ? formatNumber($selectedItem.total_bostadsarea_kvm) + ' m²' : 'N/A'}
            </div>
        </div>

        <!-- Antal lägenheter -->
        {#if $selectedItem.financial_plan_antal_lagenheter}
            <div class="info-card">
                <div class="info-header">
                    <i class="fa-solid fa-building fa-sm icon-detail"></i>
                    <h6>Antal lägenheter</h6>
                </div>
                <div class="info-value">
                    {formatNumber($selectedItem.financial_plan_antal_lagenheter)}
                </div>
            </div>
        {/if}

        <!-- Belåning per kvm bostadsarea -->
        {#if $selectedItem.financial_plan_belaning_per_kvm_bostadsarea_kr}
            <div class="info-card">
                <div class="info-header">
                    <i class="fa-solid fa-coins fa-sm icon-detail"></i>
                    <h6>Belåning per m²</h6>
                </div>
                <div class="info-value">
                    {formatCurrency($selectedItem.financial_plan_belaning_per_kvm_bostadsarea_kr)}
                </div>
            </div>
        {/if}

        <!-- Årsavgift per kvm bostadsarea -->
        {#if $selectedItem.financial_plan_arsavgift_per_kvm_bostadsarea_kr}
            <div class="info-card">
                <div class="info-header">
                    <i class="fa-solid fa-receipt fa-sm icon-detail"></i>
                    <h6>Årsavgift per m²</h6>
                </div>
                <div class="info-value">
                    {formatCurrency($selectedItem.financial_plan_arsavgift_per_kvm_bostadsarea_kr)}
                </div>
            </div>
        {/if}

        <!-- År -->
        {#if $selectedItem.financial_plan_year}
            <div class="info-card">
                <div class="info-header">
                    <i class="fa-solid fa-calendar fa-sm icon-detail"></i>
                    <h6>År</h6>
                </div>
                <div class="info-value">
                    {$selectedItem.financial_plan_year}
                </div>
            </div>
        {/if}

        <!-- Fastighetsbeteckning -->
        {#if $selectedItem.fastighetsbeteckning}
            <div class="info-card full-width">
                <div class="info-header">
                    <i class="fa-solid fa-map-marker-alt fa-sm icon-detail"></i>
                    <h6>Fastighetsbeteckning</h6>
                </div>
                <div class="info-value">
                    {$selectedItem.fastighetsbeteckning}
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    .info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 20px;
        margin-bottom: 25px;
    }

    .info-card {
        background-color: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: transform 0.2s, box-shadow 0.2s;
        border: 1px solid #e9ecef;
    }

    .info-card.full-width {
        grid-column: 1 / -1;
        margin-top: 0;
    }

    .info-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .info-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    .info-header h6 {
        font-size: 0.9rem;
        color: #495057;
        font-weight: 500;
    }

    .info-value {
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--box-title-color);
        text-align: left;
    }
</style>
